import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import type { FC } from 'react';

interface DynamicKeyValueListProps {
  name: string;
  label?: string;
  keyPlaceholder?: string;
  valuePlaceholder?: string;
  buttonText?: string;
}

export const DynamicKeyValueList: FC<DynamicKeyValueListProps> = ({
  name,
  keyPlaceholder = 'Key',
  valuePlaceholder = 'Value',
  buttonText = 'Add Item',
}) => {
  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <div className="space-y-4">
          {fields.map(({ key, name, ...restField }) => (
            <div key={key} className="flex flex-col gap-2">
              <div className="flex items-center gap-2">
                <Form.Item
                  {...restField}
                  name={[name, 'key']}
                  rules={[{ required: true, message: 'Key is required' }]}
                  className="mb-0"
                >
                  <Input placeholder={keyPlaceholder} />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'value']}
                  rules={[{ required: true, message: 'Value is required' }]}
                  className="mb-0"
                >
                  <Input placeholder={valuePlaceholder} />
                </Form.Item>
                <MinusCircleOutlined
                  className="text-red-500 cursor-pointer"
                  onClick={() => remove(name)}
                />
              </div>
            </div>
          ))}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {buttonText}
            </Button>
          </Form.Item>
        </div>
      )}
    </Form.List>
  );
};
